// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AgendarCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /agenda/agendar_compromisso
 *
 * NON-CANON endpoint: Creates a new compromisso (appointment) from the agenda.
 * Returns the created compromisso ID on success.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_AgendarCompromissoResponseDados {
compromisso_id: number
}

export type Agenda_AgendarCompromissoResponse = ApiResponse<Agenda_AgendarCompromissoResponseDados>;

registerResponseContract('Agenda_AgendarCompromissoResponse', {
  compromisso_id: { type: 'number',  required: true },
})
